<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <circle
      cx="5"
      cy="12"
      r="1.6"
    />
    <circle
      cx="12"
      cy="12"
      r="1.6"
    />
    <circle
      cx="19"
      cy="12"
      r="1.6"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconDots3Horizontal',
  props: { size: { type: [String, Number], default: 14 } },
};
</script>
